module.exports = __webpack_public_path__ + "slack-3-826ad6479942e9985503efc4af7c8ee3.webp";